import { create } from 'zustand'

type SelectionStoreState = {
  selectedIds: Set<string>
  lastSelectedId: string | null
}

type SelectionStoreActions = {
  selectOnly: (id: string) => void
  toggle: (id: string) => void
  selectRange: (orderedIds: string[], toId: string) => void
  clear: () => void
}

export type SelectionStore = SelectionStoreState & SelectionStoreActions

export const useSelectionStore = create<SelectionStore>(set => ({
  selectedIds: new Set(),
  lastSelectedId: null,
  selectOnly: id => set({ selectedIds: new Set([id]), lastSelectedId: id }),
  toggle: id =>
    set(state => {
      const next = new Set(state.selectedIds)
      if (next.has(id)) {
        next.delete(id)
        return {
          selectedIds: next,
          lastSelectedId: next.size === 0 ? null : state.lastSelectedId
        }
      }
      next.add(id)
      return { selectedIds: next, lastSelectedId: id }
    }),
  selectRange: (orderedIds, toId) =>
    set(state => {
      const anchor = state.lastSelectedId ?? toId
      const anchorIdx = orderedIds.indexOf(anchor)
      const toIdx = orderedIds.indexOf(toId)
      if (anchorIdx === -1 || toIdx === -1) {
        return { selectedIds: new Set([toId]), lastSelectedId: toId }
      }
      const [from, to] =
        anchorIdx < toIdx ? [anchorIdx, toIdx] : [toIdx, anchorIdx]
      return {
        selectedIds: new Set(orderedIds.slice(from, to + 1)),
        lastSelectedId: toId
      }
    }),
  clear: () => set({ selectedIds: new Set(), lastSelectedId: null })
}))
